module.exports = __webpack_public_path__ + "static/media/notification-blank.5f068f00.svg";